<!-- HTML !-->
<button name="button" [type]="typeBtn" class="button" role="button" [ngClass]="{ bgActive: activeBg }"
  [disabled]="disabled">
  @if (showImg) {
  <!-- <img [src]="pathIcon" alt=""> -->
  <img [src]="'assets/icons/unicolor/' + icon + '-white.svg'" alt="">
  }
  <span>
    {{ contentBtn }}
  </span>
</button>